export const LOCALE_TO_ZENDESKLOCALE = {
  en: "en-150",
  "no-no": "no"
};
const getHostName = () => {
  let hostName = "";
  if (window && window.location && window.location.hostname) {
    hostName = window.location.hostname.replace("www.", "");
  }
  return hostName;
};
export const getHelpCenterUrl = ({
  locale = "en"
} = {}) => {
  const hostName = getHostName();
  return `https://help.${hostName}/hc/${LOCALE_TO_ZENDESKLOCALE[locale?.toLowerCase()] || locale?.toLowerCase()}`;
};